import { render, staticRenderFns } from "./NoActiveConversation.vue?vue&type=template&id=5be890aa&scoped=true&"
import script from "./NoActiveConversation.vue?vue&type=script&lang=js&"
export * from "./NoActiveConversation.vue?vue&type=script&lang=js&"
import style0 from "./NoActiveConversation.vue?vue&type=style&index=0&id=5be890aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be890aa",
  null
  
)

export default component.exports